import api from "../services/api";

export const patchVendor = (vendorId, payload) => {
  return new Promise((resolve, reject) => {
    api
      .patch(`vendors/${vendorId}/?vendorId=${vendorId}`, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};
